// src/components/spatial/utils/drawGrid.js

export const buildGridLines = ({
  width,
  height,
  gridSize = 20,
  majorEvery = 5,
  offsetX = 0,
  offsetY = 0,
  zoom = 1,
}) => {
  const linesMinor = [];
  const linesMajor = [];

  const scaled = gridSize * zoom;

  const startX = -offsetX % scaled;
  const startY = -offsetY % scaled;

  let index = 0;

  for (let x = startX; x < width; x += scaled) {
    const target = index % majorEvery === 0 ? linesMajor : linesMinor;

    target.push({
      x1: x,
      y1: 0,
      x2: x,
      y2: height,
    });

    index++;
  }

  index = 0;

  for (let y = startY; y < height; y += scaled) {
    const target = index % majorEvery === 0 ? linesMajor : linesMinor;

    target.push({
      x1: 0,
      y1: y,
      x2: width,
      y2: y,
    });

    index++;
  }

  return {
    minor: linesMinor,
    major: linesMajor,
  };
};